import { Component, OnInit } from '@angular/core';
import { DataService } from './services/data.service';
import { AdminSettingsService } from './services/admin-settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'ccs-crm-app';

  constructor(
    private dataService: DataService,
    private admSettingsService: AdminSettingsService
  ) {}

  ngOnInit() {
    const savedMode = localStorage.getItem('darkMode') === 'true';
    if (savedMode) {
      document.body.classList.add('dark-theme');
    }

    // set lead colors
    let leadColors = this.dataService.getLeadStatusColor();
    // if (!leadColors) {
    //   this.dataService.setLeadStatusColor({
    //     New: '#3399ff',
    //     Open: '#1ecbe1',
    //     'In Progress': '#ffcd39',
    //     'Call back': '#9d4edd',
    //     'Closed': '#adb5bd',
    //   });
    // }

    let dealColors = this.dataService.getDealStatusColor();
    if (!dealColors) {
      this.dataService.setDealStatusColor({
        Open: '#3399ff',
        Loss: '#1ecbe1',
        'On Hold': '#ffcd39',
        Won: '#adb5bd',
      });
    }
  }
}
